import React, { useEffect, useState } from 'react';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Button, TextField } from '@mui/material';
import { useRecoilState, useRecoilValue } from 'recoil';
import { sentenceRangeState } from '../../../globalStates/gameMain/sentenceRange';
import { Link } from 'react-router-dom';
import { levelState } from '../../../globalStates/general/level';
import { gameStatusState } from '../../../globalStates/general/gameStatus';
import { useMedia } from 'use-media';

const SelectSentence = (props) => {
  const [gameStatusValue, setGameStatusValue] = useRecoilState(gameStatusState);
  const [createIdDisplay, setCreateIdDisplay] = useState("none");
  const [sentenceId, setSentenceIdState] = useState();
  const [createStatus, setCreateStatus] = useState("");
  const [startId, setStartId] = useState("");
  const [endId, setEndId] = useState("");
  const [sentenceRange, setSentenceRange] = useRecoilState(sentenceRangeState);
  const [level, setLevel] = useRecoilState(levelState);
  const isPC = useMedia({ minWidth: '1000px' });

  useEffect(() => {
    const tmpSentenceRange = {
      min: startId,
      max: endId
    }
    console.log(startId, endId);

    setSentenceRange(tmpSentenceRange);
  }, [startId, endId]);

  const selectSentenceBtnStyle = css`
   button{
        /*アニメーションの起点とするためrelativeを指定*/
        position: relative;
        overflow: hidden;
        /*ボタンの形状*/
        text-decoration: none;
        display: inline-block;
        border: 2px solid #555;/* ボーダーの色と太さ */
        padding: 10px 30px;
        text-align: center;
        outline: none;
        /*アニメーションの指定*/
        transition: ease .2s;
    }

    /*ボタン内spanの形状*/
    button span {
      position: relative;
      z-index: 3;/*z-indexの数値をあげて文字を背景よりも手前に表示*/
      color:#555555;
    }

    button:hover span{
      cursor: pointer;
      color:#fff;
    }
    /*== 背景が流れる（中央から横全体） */
    button:before {
      content: '';
        /*絶対配置で位置を指定*/
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
        /*色や形状*/
      background: #333;
      width: 100%;
      height: 100%;
        /*アニメーション*/
      transition: transform .3s cubic-bezier(0.8, 0, 0.2, 1) 0s;
      transform: scale(0, 1);
      transform-origin: top;
    }

    /*hoverした際の形状*/
    button:hover:before{
      transform:scale(1, 1);
    }


    button {
      text-align: center;
      width: 260px;
      height: 60px;
      margin-top: 20px;
      cursor: pointer;
      font-size: 1.5em;
      background-color: #fff;
      color: #555555;
      border-radius: 10px;
    }
  `;
  const createIdWindowStyle = css`
    margin-top: ${isPC ? "50px" : "0px"};
    text-align: center;
    display: ${createIdDisplay};
    color: #555;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: ${isPC ? "translate(-50%, -50%)" : "translate(-70%, -50%)"};
    border-radius: 15px;
    background-color: #e7e7e7;
    animation: bigger 1s ease forwards;
    z-index: 10;

    #close-btn {
      position: absolute;
      top: 10px;
      right: 20px;
      font-size: 1.5em;
      cursor: pointer;
    }
    p.message {
      margin-top: 30px;
      margin-bottom: 70px;
      font-size: 0.8em;
    }
    div.create-status {
      font-size: 0.8em;
      color: ${createStatus ? "green" : "red"};
    }
    h4 {
      font-size: 1.2em;
      text-align: center;
      margin-top: 90px;
      }

    button {
      text-align: center;
    }
    @keyframes bigger {
      0% {
        width: 0px;
        height: 0px;
        opacity: 0;
      }
      100% {
        width: ${isPC ? "70vw" : `110vw`};
        height: ${isPC ? `calc(${window.innerHeight}px - 40%)` : `calc(${window.innerHeight}px)`};
        padding-bottom: 80px;
        opacity: 1;
      }
    }
  `;

  return (
    <>
      <div css={createIdWindowStyle}>
        <div id="close-btn" onClick={() => { setCreateIdDisplay("none") }}>X</div>
        <h4>英文の範囲をIDで指定してください</h4>
        <p className='message'>※ 英文一つを指定したい場合は開始・終了に同じIDを入力してください。<br /><a target="_blank" href='https://honeycombgrammar.web.app/'>IDの確認はこちら</a></p>


        <TextField
          value={startId}
          onChange={(e) => {
            if (e.target.value === "" || 1 <= e.target.value && e.target.value <= 300) {
              setStartId(e.target.value);
            }
          }}
          label="開始ID"
          id="selectNumber"
          sx={{
            m: 1, width: '90px', marginRight: "20px"
          }}
        />
        <TextField
          onChange={(e) => {
            if (e.target.value === "" || 1 <= e.target.value && e.target.value <= 300) {
              setEndId(e.target.value);
            }
          }}
          value={endId}
          label="終了ID"
          id="selectNumber"

          sx={{
            m: 1, width: '90px', marginLeft: "20px"
          }}
        /><br />
        {startId != "" && endId != "" ? (
          <button onClick={() => {
            setCreateIdDisplay("none");
            props.setLevel("self");

          }}><span>OK</span></button>
        ) : (
          <p style={{ color: 'gray' }}>IDが入力されていません</p>

        )
        }

      </div>
      <div css={selectSentenceBtnStyle}>
        {
          level === "self" ? (
            <>
              <button style={{ backgroundColor: '#555555', color: '#ffffff', cursor: 'pointer' }} onClick={() => {
                setCreateIdDisplay("block");
              }}><span style={{ color: 'white' }}>sentence ID</span></button><br />
            </>
          ) : (
            <>
              <button onClick={() => {
                setCreateIdDisplay("block");
              }}><span>sentence ID</span></button>
            </>
          )
        }

      </div>

    </>
  )
}

export default SelectSentence
